import React from 'react'
import { useTranslation } from 'react-i18next'

import '../i18n'

import Layout from '../components/Layout/Layout'
import KvaliHeader from '../views/Main/KvaliHeader'
import ProudOfMember from '../views/Main/ProudOfMember/ProudOfMember'
import ObjectiveDecisions from '../views/Main/ObjectiveDecisions/ObjectiveDecisions'
import CertifiedAndCompliant from '../views/Main/CertifiedAndCompliant/CertifiedAndCompliant'
import DashboardView from '../views/Main/DashboardView/DashboardView'
import ApiStructure from '../views/Main/ApiStructure'
import KvaliFaq from '../views/Main/KvaliFaq/KvaliFaq'
import CaseStudies from '../views/Main/CaseStudies/CaseStudies'
import ServiceDetails from '../views/Main/ServiceDetails'

import leftGradient from '../resources/images/kvali-left-gradient.svg'
import dashboardBackgSvg from '../resources/images/dashboardBackground.svg'

export default ({ location }) => {
	const { t } = useTranslation()

	return (
		<>
			<Layout darkColor>
				<section className='header-main light-section'>
					<KvaliHeader
						headerLogoName
						headerTitle='kvaliFeatureAsideTitle2'
						headerDescription='documentPageDescription'
						hideLogoList
					/>
					<img className='image-left-container' src={leftGradient} alt='' />
				</section>
				<section className='light-section reset-mrg'>
					<ObjectiveDecisions />
				</section>
				<section className='light-section reset-mrg pos-relative'>
					<DashboardView />
					<img className='background-image-dashboard' src={dashboardBackgSvg} alt='' />
				</section>
				<section className='light-section reset-mrg'>
					<ApiStructure />
				</section>
				<section className='light-section reset-mrg'>
					<ServiceDetails data={t('documentPageServices', { returnObjects: true })} />
				</section>
				<section className='light-section reset-mrg'>
					<CaseStudies active={location.state?.active} />
				</section>
				<section className='dark-section-kvl  reset-mrg'>
					<CertifiedAndCompliant />
				</section>
				<section className='light-section reset-mrg'>
					<KvaliFaq />
				</section>
				<section className='dark-section-kvl reset-mrg'>
					<ProudOfMember />
				</section>
			</Layout>
		</>
	)
}
